<!--
 * @Author: chengleilei
 * @Date: 2025-09-26 15:36:22
 * @Description: 非轮订单-已关闭
-->
<template>
    <Card :bordered="false" dis-hover>
        <table-form :formList="formList" ref="table-form" @on-submit="onSubmit" @on-export="exportInfo">
            <Button class="ivu-ml-8" slot="extraBtn" type="error">导出</Button>
        </table-form>
        <table-page :list="tableConfig" @oinPageChange="onPageChange" @onPageSizeChange="onPageSizeChange" />
    </Card>
</template>
<script>
import tablePage from '@/components/tablePage';
import tableForm from '@/components/tableForm';
import { clearInvalidKey } from '@/libs/util.tool';
import { apiNonwheelOrderList, apiNonwheelOrderExport } from '@/api/purchase';
import { closeFormList, closeColumns } from './const';

export default {
    components: { tableForm, tablePage },
    data() {
        return {
            tableConfig: {
                current: 1,
                size: window.$pageSize,
                total: 0,
                noDataText: '暂无订单',
                columns: closeColumns,
                data: [],
                loading: false,
            },
            formList: closeFormList,
        };
    },
    activated() {
        // this.getData();
    },
    methods: {
        // 设置品牌商筛选项
        renderOptions(brandingCompanyList) {
            this.formList[7].options = brandingCompanyList;
        },
        // 获取参数
        getParams() {
            let p = this.$refs['table-form'].getFormData();
            const copyP = { ...clearInvalidKey(p) };
            copyP.status = 1005;
            const params = {
                current: this.tableConfig.current,
                size: this.tableConfig.size,
                ...copyP,
            };
            return params;
        },
        // 获取数据
        async getData() {
            try {
                this.tableConfig.loading = true;
                const res = await apiNonwheelOrderList(this.getParams());
                this.tableConfig.total = Number(res.total);
                this.tableConfig.data = (res.records || []).map((item) => {
                    return {
                        ...item,
                        activitySn: item.itemList[0].activitySn || '-',
                        amount: item.itemList[0].amount || '-',
                        brandName: item.itemList[0].brandName || '-',
                        company: item.itemList[0].company || '-',
                        orderId: item.itemList[0].orderId || '-',
                        productName: item.itemList[0].productName || '-',
                        quantity: item.itemList[0].quantity || '-',
                        skuSpec: item.itemList[0].skuSpec || '-',
                    };
                });
            } finally {
                this.tableConfig.loading = false;
            }
        },
        // 页码改变
        onPageChange(val) {
            this.tableConfig.current = val;
            this.getData();
        },
        // x条/页改变
        onPageSizeChange(val) {
            this.tableConfig.current = 1;
            this.tableConfig.size = val;
            this.getData();
        },
        // 查询
        onSubmit() {
            this.tableConfig.current = 1;
            this.getData();
        },
        // 导出
        async exportInfo() {
            try {
                this.$Message.loading({ content: '导出中...', duration: 0 });
                await apiNonwheelOrderExport(this.getParams());
                this.$Modal.confirm({
                    title: '提示',
                    content: `您好！“${this.$route.meta.title}”正在导出，请稍后在“导出列表”模块中查看，谢谢！`,
                    onOk: () => {
                        console.log('export');
                    },
                });
            } finally {
                this.$Message.destroy();
            }
        },
        // 查看物流
        onCheckBtnClick(row) {},
        // 退款
        onRefundBtnClick(row) {
            this.$refs['refundModal'].open(row);
        },
        // 退款单
        onRecordBtnClick(row) {
            this.$refs['recordModal'].open(row);
        },
    },
};
</script>
